<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-row class="bradcrumb">
            <router-link :to="{name: 'role-links' }" class="root">
                Dashboard
            </router-link>
            /
            <router-link :to="{name: 'admin-master' }" class="root">
                Admin Master
            </router-link>
            <span class="child">/ Semester</span>
        </v-row>
        <br />
        <!-- <center class="heading">
      <h3>Semester</h3>
    </center>
    <span v-if="org!=null">

    </span> -->
        <v-card class="card">
            <v-card-title class="heading justify-center">
                <span>Semester</span>
            </v-card-title>
            <v-card-text>
                <template v-if="added_configs!=null">
                    <v-row justify="center">
                        <v-col md="12" sm="12">
                            <v-data-table :headers="headers" :items="added_configs" class="elevation-1 nowrap" :search="search">
                                <template v-slot:top>
                                    <v-toolbar flat color="white">
                                        <v-spacer></v-spacer>
                                        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details> </v-text-field>
                                        <span style="width: 20px;"></span>
                                        <v-dialog v-model="dialog" max-width="500px">
                                            <template v-slot:activator="{ on }">
                                                <v-btn class="button" v-on="on">Add New Semester</v-btn>
                                            </template>
                                            <v-card>
                                                <v-card-title class="heading">
                                                    <span class="headline">{{ formTitle }}</span>
                                                </v-card-title>

                                                <v-card-text>
                                                    <v-container>
                                                        <v-row>
                                                            <v-col cols="12" sm="6" md="6">
                                                                <v-text-field v-model.trim="editedItem.name" label="Semester"></v-text-field>
                                                            </v-col>
                                                            <v-col cols="12" sm="6" md="6">
                                                                <v-checkbox v-model="editedItem.isactive" class="mx-2" label="Active"></v-checkbox>
                                                            </v-col>
                                                        </v-row>
                                                    </v-container>
                                                </v-card-text>

                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn class="button-cancel" text @click="close">Cancel</v-btn>
                                                    <v-btn class="button" :loading="save_btn_load" text @click="save">Save</v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                    </v-toolbar>
                                </template>
                                <template v-slot:item.isactive="{ item }">
                                    <v-icon v-if="item.isactive==true" color="success" class="mr-2">mdi-check-circle-outline</v-icon>
                                    <v-icon v-else color="error" class="mr-2">mdi-close-circle-outline</v-icon>
                                </template>
                                <template v-slot:item.actions="{ item }">
                                    <div>
                                        <v-avatar style="" size="33" class="edit-avatar">
                                            <v-icon class="edit-v-icon mr-2" size="18" @click="editItem(item)">edit</v-icon>
                                        </v-avatar>
                                    </div>
                                    <!-- <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon> -->
                                    <!-- <v-icon small color="error" @click="deleteItem(item)">mdi-delete-empty</v-icon> -->
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </template>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            snackbar_msg: "",
            snackbar: false,
            search: "",
            color: "",
            org: null,
            dialog: false,
            save_btn_load: false,
            //
            added_configs: null,
            headers: [
                { text: "Name", value: "name" },
                { text: "Is Active?", value: "isactive" },
                { text: "Actions", value: "actions", sortable: false },
            ],
            editedIndex: -1,
            editedItem: {
                id: "",
                name: "",
                isactive: true,
            },
            defaultItem: {
                id: "",
                name: "",
                isactive: true,
            },
        }),
        watch: {
            dialog(val) {
                val || this.close();
            },
        },
        methods: {
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            editItem(item) {
                this.editedIndex = this.added_configs.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            },
            close() {
                this.dialog = false;
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                }, 300);
            },
            save() {
                if (this.editedItem.name == "" || this.editedItem.name == null) {
                    this.showSnackbar("#b71c1c", "Please add Semester!!!");
                    return;
                }
                if (this.editedIndex > -1) {
                    this.save_btn_load = true;
                    axios
                        .post("/adminMaster/editSemester", this.editedItem)
                        .then((res) => {
                            if (res.data.status == "YES") {
                                this.showSnackbar("#4CAF50", "Semester Updated Successfully.");
                                this.added_configs = res.data.added_configs;
                                //Object.assign(this.diff_level[this.editedIndex], this.editedItem);
                            } else if (res.data.status == "NO") {
                                this.showSnackbar("#b71c1c", "Semester Already added!!!");
                            }
                        })
                        .catch((error) => {
                           // alert("in catch");
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        })
                        .finally(() => {
                            this.save_btn_load = false;
                        });
                } else {
                    this.save_btn_load = true;
                    axios
                        .post("/adminMaster/saveSemester", this.editedItem)
                        .then((res) => {
                            if (res.data.status == "YES") {
                                this.showSnackbar("#4CAF50", "Semester Added Successfully.");
                                this.added_configs = res.data.added_configs;
                                //this.diff_level.push(this.editedItem);
                            } else if (res.data.status == "NO") {
                                this.showSnackbar("#b71c1c", "Semester Already added!!!");
                            }
                        })
                        .catch((error) => {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        })
                        .finally(() => {
                            this.save_btn_load = false;
                        });
                }
                this.close();
            },

            deleteItem(item) {
                var r = confirm("Are you sure you want to delete this item?");
                if (r) {
                    const semesterId = {
                        id: item.id,
                    };
                    axios
                        .post("/adminMaster/deleteSemester", semesterId)
                        .then((res) => {
                            if (res.data.msg == "200") {
                                this.showSnackbar("#4CAF50", "Semester deleted...");
                                const index = this.added_configs.indexOf(item);
                                this.added_configs.splice(index, 1);
                            } else {
                                this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            }
                        })
                        .catch((error) => {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        })
                        .finally(() => {});
                } else {
                }
            },
        },
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "Semester" : "Edit Semester";
            },
        },
        mounted() {
            axios
                .post("/adminMaster/semester")
                .then((res) => {
                    this.org = res.data.org_list;
                    this.added_configs = res.data.added_configs;
                    // this.showSnackbar("#4CAF50","Success")
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                })
                .finally(() => {});
        },
    };
</script>
